import { HttpMethod } from "./HttpMethod";
import { ValidationResponse } from "./validation/ValidationResponse";

/**
 * Interface for all API request models.
 */
export interface IRequestModel {

    /**
     * The Uri of the request.
     */
    uri: string;

    /**
     * The HTTP method of the request.
     */
    method: HttpMethod;

    /**
     * Checks if the request is valid or not.
     * @returns Instance of ValidationResponse saying if request is valid or not.
     */
    isValid(): ValidationResponse;
}

export { HttpMethod } from "./HttpMethod";
export { ValidationResponse } from "./validation/ValidationResponse";